// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9c1161e3","239":"09cd43ca","453":"ad6335d9","455":"2cd2199d"}[chunkId] + ".chunk.js";
};